import { renderMaybeFn, Segment } from '@mi-front/core';
import { SegmentsWaveform } from '../../../components/stream/waveform/SegmentsWaveform';
import { Stream, StreamProps } from './Stream';

interface Props extends StreamProps {
  readonly segments: readonly Segment[];
  readonly compressed?: boolean;
  readonly fadeSides?: StreamProps['fadeSides'];
  readonly hideSeconds?: boolean;
}

export function SegmentsStream(p: Props) {
  const { segments, compressed, fadeSides, hideSeconds, ...rest } = p;

  return (
    <Stream
      {...rest}
      compressed={compressed}
      fadeSides={fadeSides}
      hideSeconds={hideSeconds}
      renderSvg={() => (
        <>
          <SegmentsWaveform segments={segments} />
          {p.renderSvg && renderMaybeFn(p.renderSvg)}
        </>
      )}
    />
  );
}
